module.exports = __webpack_public_path__ + "static/skutecznie-4ef3bc8980713aab842e8555e8570b68.svg";